import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '../keys'
import { ApiError, getAccessToken } from '../client'
import { API_BASE_URL } from '@/lib/config'

// Types (manually defined until API types are regenerated)
export interface FavoriteLocationResponse {
  id: number
  user_account: string
  name: string
  latitude: number
  longitude: number
  radius: number
  filters: Record<string, boolean> | null
  is_default: boolean
  created_at: string
  updated_at: string
}

export interface FavoriteLocationListResponse {
  locations: Array<FavoriteLocationResponse>
  total: number
}

async function fetchFavoriteLocations(): Promise<FavoriteLocationListResponse> {
  const token = await getAccessToken()
  const response = await fetch(`${API_BASE_URL}/api/v1/favorite-locations`, {
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  })
  if (!response.ok) {
    const detail = await response
      .json()
      .then((b) => b.detail)
      .catch(() => response.statusText)
    throw new ApiError(response.status, detail)
  }
  return response.json()
}

export function useFavoriteLocations(enabled = true) {
  return useQuery({
    queryKey: queryKeys.favoriteLocations.list(),
    queryFn: fetchFavoriteLocations,
    staleTime: 30 * 1000,
    enabled,
  })
}
